import React from "react";

const Filter = ({
  height = "19px",
  width = "20px",
  color = "#202020",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 19"
    version="1.1"
    {...props}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Reporting-UI-Halfway-Version-(1)"
        transform="translate(-458.000000, -317.000000)"
      >
        <g id="Group" transform="translate(458.500000, 318.000000)">
          <g id="Group-2">
            <path
              d="M10.2840458,0.990373673 L17.7169435,10.3792971 C18.0597483,10.8123136 17.9866172,11.4412411 17.5536006,11.7840458 C17.3769379,11.9239038 17.1582196,12 16.9328977,12 L2.06710232,12 C1.51481757,12 1.06710232,11.5522847 1.06710232,11 C1.06710232,10.7746781 1.14319854,10.5559597 1.2830565,10.3792971 L8.71595418,0.990373673 C9.05875895,0.557357121 9.68768639,0.484226023 10.1207029,0.827030793 C10.1812776,0.874985747 10.2360909,0.929798994 10.2840458,0.990373673 Z"
              id="Triangle"
              stroke={color}
              strokeWidth="2"
              transform="translate(9.500000, 6.000000) scale(1, -1) translate(-9.500000, -6.000000) "
            ></path>
            <polygon
              id="Rectangle"
              fill={color}
              points="7.5 11 11.5 11 11.5 16.2871094 7.5 18"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Filter;
